import { c as _c } from "react/compiler-runtime";
import { Button, Text } from '@chakra-ui/react';
import { useAdvisorsAttention } from '@src/components/sco/Advisors/hooks/useAdvisorsAttention';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useCreateAdvisorAgreement } from '@src/components/sco/Advisors/hooks/useCreateAdvisorAgreement';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import type { AgreementInventoryFilter, AgreementStatusFilter } from '@src/components/sco/Advisors/utils/agreementList';
import { agreementsNavItems } from '@src/components/sco/Advisors/utils/agreementsNav';
import { ReactNode } from 'react';
import { LuFileText } from 'react-icons/lu';

/**
 * FAST Agreements shell — status sub-nav rail plus section content.
 *
 * Create a New Agreement is the rail CTA so it stays reachable from every view.
 * `counts` are local inventory (muted). "Waiting on you" shows the shared your-turn count instead,
 * the same number that climbs to FAST Agreements and the site Advisors item.
 */
export const AgreementsLayout = t0 => {
  const $ = _c(22);
  const {
    activeKey,
    title,
    description,
    counts,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const createAgreement = useCreateAdvisorAgreement();
  const {
    attention
  } = useAdvisorsAttention();
  const navItems = agreementsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  useAdvisorsToolbar({
    breadcrumbs: activeKey === "all" ? advisorsBreadcrumbsWithTrail({
      title: "FAST Agreements",
      href: paths.agreements
    }) : advisorsBreadcrumbsWithTrail({
      title: "FAST Agreements",
      href: paths.agreements
    }, {
      title: activeItem?.title ?? "Agreements",
      href: activeItem?.href ?? paths.agreements
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "FAST equity terms you have drafted, sent, or been asked to sign.";
  const t3 = "FAST Agreements";
  let t4;
  if ($[2] !== attention || $[3] !== counts) {
    t4 = item_0 => ({
      key: item_0.key,
      title: item_0.title,
      href: item_0.href,
      icon: item_0.icon,
      count: item_0.key === "waiting" ? undefined : counts?.[item_0.key],
      attentionCount: item_0.key === "waiting" ? attention.agreementsWaitingOnYou : undefined
    });
    $[2] = attention;
    $[3] = counts;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = navItems.map(t4);
  let t6;
  if ($[5] !== createAgreement) {
    t6 = () => void createAgreement.create();
    $[5] = createAgreement;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LuFileText />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== createAgreement.loading || $[9] !== t6) {
    t8 = <Button loading={createAgreement.loading} size="sm" variant="cta" width="full" onClick={t6}>{t7} Create a New Agreement</Button>;
    $[8] = createAgreement.loading;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== createAgreement.error) {
    t9 = createAgreement.error ? <Text color="red.fg" fontSize="sm">{createAgreement.error}</Text> : null;
    $[11] = createAgreement.error;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== T0 || $[14] !== activeKey || $[15] !== children || $[16] !== description || $[17] !== t5 || $[18] !== t8 || $[19] !== t9 || $[20] !== title) {
    t10 = <T0 activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t5} railFooter={t8}>{t9}{children}</T0>;
    $[13] = T0;
    $[14] = activeKey;
    $[15] = children;
    $[16] = description;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
    $[20] = title;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};